import { render } from "./FoodPage.vue?vue&type=template&id=664e740f&scoped=true"
import script from "./FoodPage.vue?vue&type=script&lang=js"
export * from "./FoodPage.vue?vue&type=script&lang=js"

import "./FoodPage.vue?vue&type=style&index=0&id=664e740f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664e740f"]])

export default __exports__